<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PIC')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div>
              <sui-text-field
                ref="userInfo"
                v-model="userName"
                maxlength="50"
                style="width:100%;"
                @keyup.enter="onUserClick"
              />
            </div>
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onUserClick"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns"
        :columnsresize="true"
        :columnsautoresize="true"
        :enabletooltips="true"
        :multiselect="false"
        width="100%"
        :dataset="'dsData'"
        :initialPagesize="5"
      />
      <div class="mrB30" />
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="parentPageId"
              :default1LevelOption="'all'"
              :default2LevelOption="'select'"
              :default3LevelOption="'select'"
              applyAuthType="D"
              @select-changed="onChangeBizCodes"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:create="'PGE_CMA_00008'"
        type="button"
        class="comm_btn_solid"
        @click="onAdd"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMD_00008_P01', // eslint-disable-line vue/name-property-casing
  props: {
    parentPageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userInfo: {},
      selectedGridRowData: {},
      userName: '',
      SIT: { key: '', label: '' },
      selectedBizCode: [],
      localdata: [],
      gridColumns: [{
        text: this.$t('MSG_TXT_PIC'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_DEPT'),
        datafield: 'departmentName',
      }, {
        text: this.$t('MSG_TXT_CPNY'),
        datafield: 'companyName',
      }],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.dsData.$on(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    this.userInfo = this.$store.getters.userInfo;
    this.load();
  },
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata',
    datafields: [
      { name: 'employeeIDNumber', type: 'string', map: 'employeeIDNumber' },
      { name: 'userName', type: 'string', map: 'userName' },
      { name: 'companyName', type: 'string', map: 'companyName' },
      { name: 'departmentName', type: 'string', map: 'departmentName' },
      { name: 'knoxId', type: 'string', map: 'knoxId' },
      { name: 'servedStateCode', type: 'string', map: 'servedStateCode' },
      { name: 'userId', type: 'string', map: 'userId' },
      { name: 'epid', type: 'string', map: 'epid' },
      { name: 'email', type: 'string', map: 'email' },
    ],
  }],
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    if (this.dsData) {
      this.dsData.$off(this.dsData.EVENTS.SELECTION_CHANGED, this.onSelectGrid);
    }
  },
  destroyed() {},
  methods: {
    load() {
    },
    onListClicked(event, item) {
      this.$refs.taskIdSelect.reset();
    },
    onUserClick() {
      if (utils.isEmpty(this.userName) === true) {
        //const msg = utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_DELG_USER'));
        const msg = utils.strFormat(this.$t('MSG_ALT_INP_ID'), this.$t('MSG_TXT_PIC'));
        utils.messageBox('error', msg);
        return;
      }
      const queryParams = {
        searchEmplCond: '1',
        searchCodEmplText: utils.trim(this.userName) || '',
        searchDeptNmText: '',
      };

      http.request(this.parentPageId, 'DTS_CMY_00002', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          this.localdata = res.data;
          this.dsData.setRawData(this.localdata);
        } else {
          this.dsData.setRawData([]);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onSelectGrid(oldSelections, newSelections) {
      console.log(newSelections);
      if (!this.dsData.getSelectedIndexes().length) {
        return;
      }

      if (oldSelections.newSelections[0] > -1) {
        this.selectedGridRowData = this.dsData.getSelectedRow();
      }
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onCancel() {
      this.$emit('cancel', '');
    },
    onAdd() {
      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== ' ') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== ' ') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== ' ') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }
      if (taskId === 'ALL') {
        taskId = 'TSK_00000000';
      }

      if (utils.isEmpty(taskId) === true) {
        const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_TASK_TYPE'));
        utils.messageBox('error', msg);
        return;
      }

      const userEpId = this.selectedGridRowData ? this.selectedGridRowData.epid : '';
      if (utils.isEmpty(userEpId) === true) {
        //const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DELG_USER'));
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PIC'));
        utils.messageBox('error', msg);
        return;
      }

      const paramList = {
        authApprDlgtnUserId: userEpId || '',
        taskId: taskId || '',
      };

      http.request(this.parentPageId, 'DTS_CMA_00029', {
        data: paramList,
      }).then(res => {
        this.$emit('save', 'saved');
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
</style>
